function createBlogCollectionCard(collection) {
  const a = document.createElement('a');
  a.classList.add('blog-collection-card');
  a.classList.add('image');
  a.href = collection.handle ? `${window.Shopify.routes.root}collections/${collection.handle}` : '#';
  a.innerHTML = `
    <img alt="${collection.title}" class="blog-collection-image" loading="lazy" width="2400" height="3200" src="${collection.image.src}&width=300" onload="javascript: this.closest('.image') && this.closest('.image').classList.add('loaded')">
    <p class="blog-collection-title">${collection.title}</p>
  `
  return a;
}
function initblogs() {
  const blogCollections = [...document.querySelectorAll('[blog-collection]')]
  
  if (blogCollections.length === 0) {
    return;
  }

  blogCollections.forEach(async (el) => {
    el.classList.add('show');
    const collectionHandle = el.getAttribute('blog-collection');
    
    if (!collectionHandle) {
      el.remove();
      return;
    }
    try {
      // 获取商品信息
      const rootPath = window.Shopify.routes.root
      const response = await fetch(rootPath + `collections/${collectionHandle}.json`)
      if (!response.ok) {
        console.error(`Failed to fetch collection: ${collectionHandle}`);
        el.remove();
        return;
      }

      const res = await response.json();
      if (!(res && res.collection && res.collection.image)) {
        console.error(`Collection not found: ${collectionHandle}`);
        el.remove();
        return;
      }
      const collection = res.collection;
      
      // 生成collection卡片
      const collectionCard = createBlogCollectionCard(collection);
      // 插入到占位符中
      el.appendChild(collectionCard);
    } catch (error) {
      console.error('Error loading blog collection card:', error);
    }
  });
}
initblogs()